import { put, select, takeLatest } from 'redux-saga/effects';
import requestWrapper from 'utils/requestWrapper';
import history from 'utils/history';
import {
  LOAD_COURSES,
  UPDATE_COURSE,
  LOAD_COURSE,
  //DELETE_ATTENDANCE,
} from './constants';

import {
  loadCoursesSuccess,
  loadCoursesError,
  updateCourseSuccess,
  updateCourseError,
  loadCourseSuccess,
  loadCourseError,
  /* deleteAttendanceSuccess,
  deleteAttendanceError, */
} from './actions';

export function* loadMobileCourseSaga(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(
      localStorage.getItem('schoolinked_user'),
    );
    const role = currentUser?.role;
    const { courseID } = action;
    let courseDetailSaga = false;

    if (courseID) {
        // we get the campaigns linked to the courses
    courseDetailSaga = yield requestWrapper(
        'GET',
        `courses/${courseID}`,
        '',
        currentUser.token,
      );
    } else {
      console.error(`Error in loadMobileCourseSaga: 'courseID' is Empty!`);
    }

    if (!courseDetailSaga) {
      yield put(loadCourseSuccess(false));
    } else {
      yield put(loadCourseSuccess(courseDetailSaga));
    }
  } catch (error) {
    yield put(loadCourseError(error));
  }
}

export function* loadMobileCourses(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(
      localStorage.getItem('schoolinked_user'),
    );
    const { _id, role } = currentUser;
    const { options } = action;


    let queryOptions = {
        ...options,
      },
      itemsList = false;

    if (role == 'teacher') {
      // we get the campaigns linked to the courses
      itemsList = yield requestWrapper(
        'POST',
        `courses/teacher/${_id}/attendance`,
        queryOptions,
        currentUser.token,
      );
    } else if (role == 'parent') {
      // we get the campaigns linked to the courses
      itemsList = yield requestWrapper(
        'POST',
        `courses/students/attendance`,
        queryOptions,
        currentUser.token,
      );
    }

    if (!itemsList?.data) {
      yield put(loadCoursesSuccess(false));
    } else {
      yield put(loadCoursesSuccess(itemsList?.data));
    }
  } catch (error) {
    yield put(loadCoursesError(error));
  }
}

export function* updateCourse(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(
      localStorage.getItem('schoolinked_user'),
    );
    const { courseDetail } = action;

    let updatedCourse = false,
      isNew = !courseDetail.hasOwnProperty('_id');

    if (isNew) {
      updatedCourse = yield requestWrapper(
        'POST',
        'courses/new/',
        courseDetail,
        currentUser.token,
      );
    } else {
      updatedCourse = yield requestWrapper(
        'PATCH',
        `courses/`,
        courseDetail,
        currentUser.token,
      );
    }

    if (!updatedCourse) {
      yield put(updateCourseSuccess(false));
    } else {
      // if new we update the url, item props will be updated
      if (isNew) {
        history.push({ pathname: `/сours/${updatedCourse._id}` });
      }
      yield put(updateCourseSuccess(updatedCourse));
    }
  } catch (err) {
    yield put(updateCourseError(true));
  }
}

/* export function* deleteAttendance(action) {
  try {
    // we retrieve the token from the local storage
    const token = localStorage.getItem('token');
    const { id } = action;

    const deleteAttendance = yield requestWrapper(
      'PATCH',
      `attendance/remove`,
      {
        _id: id,
        active: false,
      },
      token,
    );

    if (deleteAttendance) {
      yield put(deleteAttendanceSuccess());
    }
  } catch (error) {
    yield put(deleteAttendanceError(error));
  }
}
 */
export default function* attendanceSaga() {
  yield takeLatest(LOAD_COURSE, loadMobileCourseSaga);
  yield takeLatest(LOAD_COURSES, loadMobileCourses);
  yield takeLatest(UPDATE_COURSE, updateCourse);
  // yield takeLatest(DELETE_ATTENDANCE, deleteAttendance);
}
